import { createAction, createReducer } from "@reduxjs/toolkit"
import { api } from "./helpers/api"

import { LOADING_INITIAL_STATE, setFailed, setReceived, setRequested } from "modules/loader-watchers/helpers/loading"

// ACTIONS
const requested = createAction("communicationTemplates/requested")
const received = createAction("communicationTemplates/received")
const failed = createAction("communicationTemplates/failed")

// REDUCER
const initialState = {
  ...LOADING_INITIAL_STATE,
  email: [],
  text: []
}

const communicationTemplatesReducer = createReducer(initialState, {
  [requested.type]: (state) => {
    setRequested(state)
  },
  [received.type]: (state, action) => {
    setReceived(state)
    const data = action.payload?.data || {}
    state.email = data.email_templates_collection || []
    state.text = data.text_templates_collection || []
  },
  [failed.type]: (state) => {
    setFailed(state)
    state.email = []
    state.text = []
  }
})

// ACTION CREATORS
// The guide's email/text templates for the booking module. The clients module gets its templates
// embedded in the clients-list response metadata; the booking flows have no such payload, so they
// read them from here instead.
export const fetchCommunicationTemplates = () =>
  api({
    url: "/guide/communication_templates",
    onStart: requested.type,
    onSuccess: received.type,
    onError: failed.type
  })

// SELECTORS
// `message` (in-app chat) has no templates, so anything that isn't email/text gets an empty list.
export const selectCommunicationTemplates = (type) => (state) => state.communicationTemplates[type] || []

export default communicationTemplatesReducer
